/**
 * Accessory Features Section
 * Handles the accessory features presentation section
 */

class AccessoryFeatures {
  constructor(section) {
    this.section = section;
    this.init();
  }

  init() {
    // Initialize section if needed
    console.log('Accessory Features section initialized');
  }
}

// Initialize all sections on page load
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-section-type="w-accessory-features"]');
  sections.forEach(section => {
    new AccessoryFeatures(section);
  });
});

// Shopify section events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.dataset.sectionType === 'w-accessory-features') {
      new AccessoryFeatures(event.target);
    }
  });
}

// Expose class globally for dynamic initialization
window.AccessoryFeatures = AccessoryFeatures;
